<template>
    <div id="components-layout-demo-side" style="height: 100vh">
        <router-view v-if="is_login" />
        <a-layout v-else style="height: 100vh">
            <a-layout-sider v-model:collapsed="collapsed" collapsible>
                <div class="logo">
                    <h4 v-if="!collapsed" style="color: #fff; width: 100%; overflow: hidden; line-height: 40px; text-align: center;">{{ chain_name }}</h4>
                    <img v-else :src="slogo" style="width: 50px; height: auto; margin: 0 auto;"/>
                </div>
                <a-menu v-model:selectedKeys="selectedKeys" theme="dark" mode="inline">
                    <a-menu-item key="1" @click="openPage('insight')">
                        <AreaChartOutlined />
                        <span>{{ $t('insight.insight') }}</span>
                    </a-menu-item>
                    <a-menu-item key="3" @click="openPage('survey')">
                        <AimOutlined />
                        <span>{{ $t('survey.survey') }}</span>
                    </a-menu-item>
                    <a-menu-item key="2" @click="openPage('locations')">
                        <ProfileOutlined />
                        <span>{{ $t('locations.locations') }}</span>
                    </a-menu-item>
                    <a-menu-item key="5" @click="openPage('operation_log')">
                        <AuditOutlined />
                        <span>{{ $t('audit.operation_log') }}</span>
                    </a-menu-item>
                    <a-menu-item key="4" @click="openPage('setting')">
                        <SettingOutlined />
                        <span>{{ $t('setting.setting') }}</span>
                    </a-menu-item>
                </a-menu>
                <h5 v-if="!collapsed" style="bottom: 50px; left: 50px; text-align: center; color: #fff;color: rgb(255, 255, 255);position: fixed;">{{ $t('setting.version_label') }} {{ version + ' (' + build_number + ')' }}</h5>
                <h5 v-else style="bottom: 50px; left: 25px; text-align: center; color: #fff;color: rgb(255, 255, 255);position: fixed;">{{ version }}</h5>
            </a-layout-sider>
            <a-layout>
                <a-layout-content>
                    <router-view/>
                    <a-flex class="footer_nav">
                        <div class="footer_nav_item" @click="openPage('insight')" :class="{current: now_path.indexOf('/insight') > -1}">
                            <span><AreaChartOutlined /></span>
                            <span style="padding-top: 5px;">{{ $t('insight.insight') }}</span>
                        </div>
                        <div class="footer_nav_item" @click="openPage('locations')" style="border-left: none; border-right: none;" :class="{current: now_path == '/locations'}">
                            <span><ProfileOutlined /></span>
                            <span style="padding-top: 5px;">{{ $t('locations.locations') }}</span>
                        </div>  
                        <div class="footer_nav_item" @click="openPage('operation_log')" style="border-left: none; border-right: none;" :class="{current: now_path == '/audit/action/list'}">
                            <span><AuditOutlined /></span>
                            <span style="padding-top: 5px;">{{ $t('audit.operation_log') }}</span>
                        </div>
                        <div class="footer_nav_item" @click="openPage('survey')" style="border-left: none; border-right: none;" :class="{current: now_path == '/survey'}">
                            <span><AimOutlined /></span>
                            <span style="padding-top: 5px;">{{ $t('survey.survey') }}</span>
                        </div>
                        <div class="footer_nav_item" @click="openPage('setting')" :class="{current: now_path == '/setting'}">
                            <span><SettingOutlined /></span>
                            <span style="padding-top: 5px;">{{ $t('setting.setting')}}</span>
                        </div>
                    </a-flex>
                </a-layout-content>
            </a-layout>
        </a-layout>
        <div class="loading-layer" v-show="show_loading">
            <a-spin size="large"></a-spin>
        </div>
    </div>
</template>

<script>
    // import Vue from 'vue';
    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

    import {
        ProfileOutlined,
        AreaChartOutlined,
        SettingOutlined,
        AimOutlined,
        AuditOutlined,
    } from '@ant-design/icons-vue';
    
    export default {
        name: 'AppPage',
        components: {
            ProfileOutlined,
            AreaChartOutlined,
            SettingOutlined,
            AimOutlined,
            AuditOutlined,
        },
        data() {
            return {
                is_login: this.$router.currentRoute.value.fullPath.indexOf('/login') > -1 ? true : false,
                collapsible: false,
                selectedKeys: [],
                collapsed: false,
                version: this.$store.state.app.version,
                build_number: this.$store.state.app.build_number,
                is_mobile: this.$store.state.app.is_mobile,
                now_path: this.$router.currentRoute.value.fullPath,
            };
        },
        beforeMount() {
            // console.log(this.$router.currentRoute.value.fullPath);
            this.is_login = this.$router.currentRoute.value.fullPath.indexOf('/login') > -1 ? true : false;
        },
        updated() {},
        beforeCreate() {},
        created() {
        },
        watch: {
            '$route'() {
                this.is_login = this.$router.currentRoute.value.fullPath.indexOf('/login') > -1 ? true : false;

                let now_path = this.$router.currentRoute.value.fullPath;
                this.now_path = now_path;

                if (now_path.indexOf('/insight') > -1) {
                    this.selectedKeys = ['1'];
                } else if (now_path.indexOf('/locations') > -1) {
                    this.selectedKeys = ['2'];
                } else if (now_path.indexOf('/setting') > -1) {
                    this.selectedKeys = ['4'];
                } else if (now_path.indexOf('/survey') > -1) {
                    this.selectedKeys = ['3'];
                } else if (now_path.indexOf('/audit') > -1) {
                    this.selectedKeys = ['5'];
                }
            }
        },
        computed: {
            ...mapGetters({
                show_loading: 'app/get_loading',
                chain_name: 'app/get_chain_name',
                slogo: 'app/get_slogo',
            }),
            ...mapState({
            }),
        },
        methods: {
            openPage(type) {
                if (type === 'insight') {
                    this.$router.push({
                        path: '/insight/home'
                    });
                } else if (type === 'locations') {
                    this.$router.push({
                        path: '/locations'
                    });
                } else if (type === 'setting') {
                    this.$router.push({
                        path: '/setting'
                    });
                } else if (type === 'survey') {
                    this.$router.push({
                        path: '/survey'
                    });
                } else if (type === 'operation_log') {
                    this.$router.push({
                        path: '/audit/action/list'
                    });
                }
            },
            ...mapActions({
            }),
            ...mapMutations({
            })
        }
    };

</script>

<style scoped>
    .loading-layer {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1001;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background-color: #eee;
        opacity: 0.7;
    }

    #components-layout-demo-side .logo {
        height: 60px;
        margin: 16px;
        /* background: rgba(255, 255, 255, 0.3); */
    }

    .site-layout .site-layout-background {
        background: #fff;
    }
    [data-theme='dark'] .site-layout .site-layout-background {
        background: #141414;
    }
    .ant-layout-content {
        margin: 16px;
    }
    .footer_nav {
        display: none;
    }

    @media screen and (max-width: 768px) {
        .ant-layout-sider {
            display: none;
        }

        .ant-layout-content {
            margin: 5px;
        }

        .footer_nav {
            display: block;
            position: fixed;
            bottom: 0;
            width: 102%;
            left: -7px;
        }

        .footer_nav .footer_nav_item {
            width: 24.85%;
            display: inline-block;
            text-align: center;
            height: 55px;
            font-size: 16px;
            color: #666;
            background-color: #fff;
            padding-top: 7px;
        }

        .footer_nav .footer_nav_item span {
            display: block;
        }

        .footer_nav .footer_nav_item.current {
            color: #1677ff;
        }
    }
</style>
